import React, { useEffect, useRef, useState, useContext, useMemo } from 'react';
import { QuestionnaireDialog, useStoreConfiguration } from '@desquared/wave-cxm-react';
import { WaveEntityType } from '@desquared/wave-cxm-api';
import { useRouter } from 'next/router';
import LoaderStore from '@/store/loader';
import { questionnaireRedirectionLink, IsFromThankYouPage } from '@/store/questionnaire';
import { ModalContext } from '@/contexts/ModalProvider';
import { useTranslations } from 'next-intl';

export default function QuestionnaireComponent({ user, touchpoint }) {
  const { api: waveCxmApi, customerId, updateCustomerId } = useStoreConfiguration();
  const [open, setOpen] = useState(true);
  const [templateId, setTemplateId] = useState();
  const router = useRouter();
  const hasCheckedQuestionnaire = useRef(false);
  const { openActionModal, close } = useContext(ModalContext);
  const [success, setSuccess] = useState(false);
  const { query } = router;
  const t = useTranslations();

  useEffect(() => {
    if (IsFromThankYouPage.getValue() && !user?._id) return;
    if (!IsFromThankYouPage.getValue() && !query?.customerId) return;
    LoaderStore.setIsVisible(true);
    if (waveCxmApi) {
      if (!hasCheckedQuestionnaire.current && (!!user?._id || !!query?.customerId)) {
        if (query?.customerId) {
          updateCustomerId(query?.customerId);
        }
        const checkQuestionnaire = async () => {
          const response = await waveCxmApi?.client.waveEntities.checkWaveEntities({
            customerId: IsFromThankYouPage.getValue() ? user?._id : query?.customerId,
            waveEntityTypes: [WaveEntityType.SURVEY, WaveEntityType.NPS_SURVEY],
            touchpoint: touchpoint,
          });
          hasCheckedQuestionnaire.current = true;
          if (response.successful && response.data?.length > 0) {
            setSuccess(true);
            setTemplateId(response.data[0].id);
            LoaderStore.setIsVisible(false);
          } else {
            LoaderStore.setIsVisible(false);
            if (user?._id) {
              setOpen(false);
              openActionModal({
                closeOnOuterClick: true,
                hasCenteredText: true,
                title: t('common.questionnaire.wrong_user'),
                text: t('common.questionnaire.wrong_user_description'),
                actions: [
                  {
                    btnLabel: t('common.questionnaire.wrong_user_button'),
                    onClick: () => {
                      close();
                      questionnaireRedirectionLink.update('');
                      router.push('/');
                    },
                  },
                ],
                closeOnOuterClick: false,
              });
            } else if (!user?._id) {
              questionnaireRedirectionLink.update(router.asPath);
              router.push('/login');
            }
          }
        };
        checkQuestionnaire();
      }
    }
  }, [waveCxmApi, user?._id, query]);
  return (
    <>
      {templateId && success ? (
        <QuestionnaireDialog
          open={open}
          setOpen={setOpen}
          templateId={templateId} // taken from checkWaveEntities response
          fullScreen={true}
          stepperVariant={'tab'}
          touchpoint={touchpoint}
          primaryActionVisibleOnAppointmentSuccess={true} //or false
          closeButtonVisibleOnAppointmentSuccess={true} //or false
          redirectionUrlOnClose={process.env.NEXT_PUBLIC_HOSTNAME}
        />
      ) : null}
    </>
  );
}
